// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2BCCZ","info":"Note_info__C644G","note":"Note_note__1WFoY","actions":"Note_actions__3PG0D"};